import type { StatusTone } from '@/components/ui';

// Shared helpers for job-run rendering — used by the admin run history
// (/admin/jobs/$key) and the tenant run history (/settings/jobs/$key).

export function runStatusTone(status: string): StatusTone {
  if (status === 'succeeded') return 'active';
  if (status === 'failed') return 'dnc';
  return 'inactive';
}

export function formatDuration(ms?: number | null): string {
  if (ms == null) return '—';
  if (ms < 1000) return `${ms} ms`;
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(1)} s`;
  const m = Math.floor(s / 60);
  return `${m}m ${Math.round(s % 60)}s`;
}

export function formatTotals(totals: Record<string, number>): string {
  const entries = Object.entries(totals);
  if (entries.length === 0) return '—';
  return entries.map(([k, v]) => `${k}: ${v}`).join(', ');
}
